import {
  CANADA_AGE_REQUIREMENT,
  INDIVIDUAL_PROVINCE_STATE_AGE_REQUIREMENTS,
  US_AGE_REQUIREMENT,
} from "@/constants/checkout";

const getAgeRequirementForState = (countryCode: string, state?: string) =>
  (state && INDIVIDUAL_PROVINCE_STATE_AGE_REQUIREMENTS[state.toLowerCase()]) ||
  (countryCode === "CA" ? CANADA_AGE_REQUIREMENT : US_AGE_REQUIREMENT);

export default getAgeRequirementForState;
